import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Image from 'components/common/Image'
import Link from 'components/common/Link/Link'
import Rating, { BazaarVoiceRating } from 'components/common/Rating'
import SpecialOrder from 'components/common/SpecialOrder'
import { expandBazaarVoiceReviewTabAndScrollDown } from 'helpers/custom-events'
import withSetBazaarVoiceInlineRatings from 'components/common/hoc/withBazaarVoiceInlineRatings/withSetBazaarVoiceInlineRatings'

const TireHeader = ({
  brandDetailsUrl,
  productName,
  brandLogo,
  bvId,
  isSpecialOrder
}) =>
  <Wrapper>
    <Link to={ brandDetailsUrl }><Image data-at-tireline-brand-logo src={ brandLogo } alt="brand-logo" width="132px" /></Link>
    <Title data-at-heading="product-name">{ productName }</Title>
    {
      isSpecialOrder && <SpecialOrder />
    }
    {
      bvId ?
        <BazaarVoiceRating
          showRatingMax
          bvId={ bvId }
          anchor
          prevent
          handler={ expandBazaarVoiceReviewTabAndScrollDown } /> :
        <Rating noReviews />
    }
  </Wrapper>

export default withSetBazaarVoiceInlineRatings(TireHeader)

TireHeader.propTypes = {
  brandDetailsUrl: PropTypes.string,
  brandLogo: PropTypes.string,
  bvId: PropTypes.string,
  isSpecialOrder: PropTypes.bool,
  productName: PropTypes.string
}

const Wrapper = styled.div`
  position: relative;
  color: ${Theme.colors.black};
  border-bottom: 1px solid ${Theme.colors.light_grey};
  ${Mixin.font.GothamBook(14)}
  ${Mixin.responsive('padding', '0 0 20px', '31px 0 22px')}
  ${Mixin.responsive('margin-bottom', '24px', '0')}
  ${Media.mobile`
    border-bottom: none;
  `}
`

const Title = styled.h1`
  margin: 15px 0 20px;
  ${Mixin.font.GothamBold(24)}
`
